/**
 * Utility functions for persisting the assignedTo filter value in localStorage
 * The value persists across page refreshes and navigation, and is only cleared on logout
 */

const STORAGE_KEY = 'assignedTo_filter';

/**
 * Save the assignedTo filter value to localStorage
 * @param value - The assignedTo value to persist (user ID, 'me', 'unassigned', or 'all')
 */
export const saveAssignedTo = (value: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (error) {
    // Silently handle localStorage errors (e.g., quota exceeded, privacy mode)
    console.warn('Failed to save assignedTo filter to localStorage:', error);
  }
};

/**
 * Retrieve the assignedTo filter value from localStorage
 * @returns The persisted assignedTo value, or null if not found
 */
export const getAssignedTo = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    // Silently handle localStorage errors
    console.warn('Failed to retrieve assignedTo filter from localStorage:', error);
    return null;
  }
};

/**
 * Clear the assignedTo filter value from localStorage
 * This should be called on logout to prevent stale data
 */
export const clearAssignedTo = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Silently handle localStorage errors
    console.warn('Failed to clear assignedTo filter from localStorage:', error);
  }
};
